import { SearchCounts } from 'shared/models/search';

/**
 * Format SearchCounts as a human-readable summary string.
 * @param counts The counts object (nullable)
 * @param suffix Text to append when no breakdown (e.g., "Candidates", "candidates found")
 */
export function formatCountsSummary(counts: SearchCounts | null | undefined, suffix = 'Total Candidates'): string {
    if (!counts) {
        return `0 ${suffix}`;
    }

    const parts: string[] = [];
    if (counts.ready > 0) parts.push(`${counts.ready.toLocaleString()} Ready`);
    if (counts.inCooldown > 0) parts.push(`${counts.inCooldown.toLocaleString()} In Cooldown`);
    if (counts.needsEmail > 0) parts.push(`${counts.needsEmail.toLocaleString()} Need Email`);
    if (counts.blacklisted > 0) parts.push(`${counts.blacklisted.toLocaleString()} Blacklisted`);

    if (parts.length === 0) {
        return `${counts.total.toLocaleString()} ${suffix}`;
    }

    return `${counts.total.toLocaleString()} Total (${parts.join(', ')})`;
}
